export default __webpack_public_path__ + "static/media/casino-hover.7d0fa2d6.webp";